export default "__VITE_ASSET__CHuqETzb__"